export const isRoundTrip = (locations: string[]): boolean => {
  if (locations.length % 2 === 1 || locations.length === 0) {
    return false;
  }

  let start = 0;
  let end = locations.length - 1;

  while (start <= end) {
    if (locations[start] === locations[end]) {
      start += 1;
      end -= 1;
    } else {
      break;
    }
  }

  return start - end === 1;
};
